import $ from 'jquery';
import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-search-form-collapsible]';
const PLUGIN_NAME = 'searchFormCollapsible';

const log = debug('site-header/header-controller:search');

class SearchFormCollapsible {
	constructor(element, options) {
		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.enabled = false;

		this.formElements = this.selectors.selectTarget(
			this.options.elementsSelector,
			this.$element
		);

		this.watch();

		log('ready', this, this.$target);
	}

	watch() {
		log('watching');

		this.$element.on('togglesearch', this.toggle.bind(this));
		this.$element.on('disablesearch', this.disable.bind(this));
	}

	enable() {
		this.formElements.removeAttr('disabled');
		this.enabled = true;
		this.formElements[0].focus();
		log('enable');
	}

	disable() {
		this.formElements.attr('disabled', 'disabled');
		this.enabled = false;
		log('disable');
	}

	toggle() {
		const handler = this.enabled
			? this.disable.bind(this)
			: this.enable.bind(this);
		log('toggle');
		handler();
	}
}

SearchFormCollapsible.DEFAULTS = {};

plugin(PLUGIN_NAME, SearchFormCollapsible);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./client/src/site__scf001/components/search/global-search/search-form-collapsible.js